import { CalendarOptions } from '@fullcalendar/core';
import nlLocale from '@fullcalendar/core/locales/nl';
import { updateEventTimeSpan } from './updateEventTimeSpan';
import { openNewEventModal } from './openNewEventModal';
import moment from 'moment';
import { eventClickHandler } from './EventHandlers/handleEventClick';
import { setWeekendColors } from './Utils/setWeekendColors';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import { getViewTimeLine } from './getView';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';

export function getTimeLineOptions(agendaEl: HTMLDivElement) {
    const url = agendaEl.dataset.tableName;
    const eventSourceUrl = `/timeline/${url}`;
    const eventResourcesUrl = `/timeline/${url}/resource`;

    const eventRecordUrl = `/data/${url}`;

    const filterColumnName = agendaEl.dataset.filterColumnName;

    var employeeId;
    var isEditableDate;
    document.addEventListener('selectedEmployeeChanged', function (event) {
        const customEvent = event as CustomEvent;
        const { selectedEmployee, isContentEditableDate } = customEvent.detail;
        employeeId = selectedEmployee;
        isEditableDate = isContentEditableDate;
    });

    const calendarOptions: CalendarOptions = {
        //!TODO schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        plugins: [resourceTimelinePlugin, dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
        initialView: getViewTimeLine(window.innerWidth),
        aspectRatio: 3,
        height: 'auto',
        locale: nlLocale,
        eventOrder: ["title"],
        expandRows: true,
        allDaySlot: false,
        editable: true,
        eventResizableFromStart: true,
        selectable: true,
        resourceAreaWidth:"10%",
        slotLabelInterval: { hour : 1 },
        slotMinTime: '06:00:00',
        slotMaxTime: '21:00:00',
        slotDuration: { minute: 15 },
        slotLabelFormat: [{
            weekday: 'long',
            month: 'numeric',
            day: 'numeric',
            omitZeroMinute: false,
            meridiem: 'short',
            hour12: false,
        }, {
            hour: '2-digit',
            minute: '2-digit',
            omitZeroMinute: false,
            meridiem: 'short',
            hour12: false,
        }],
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'resourceTimelineDay,resourceTimelineWeek'
        },
        resourceAreaHeaderContent: agendaEl.dataset.resourceAreaHeaderContent ?? 'Employees',
        resources: eventResourcesUrl,
        events: eventSourceUrl,

        eventDidMount: function (info) {
            //add event information to the event for testing purposes
            info.el.setAttribute('data-event-title', info.event.title);
            info.el.setAttribute('data-event-start', info.event.start.toISOString());
            if(info.event.end){
                info.el.setAttribute('data-event-end', info.event.end.toISOString());
            }
            info.el.addEventListener('click', () => {
                eventClickHandler(info, eventRecordUrl);
            });
        },
        eventResize: function (arg) {
            updateEventTimeSpan(arg, eventSourceUrl);
        },
        eventDrop(arg) {
            updateEventTimeSpan(arg, eventSourceUrl);
        },
        select: function (info) {
            if (info.resource["id"] != undefined) {
                employeeId = info.resource["id"];
            }

            if ((isEditableDate && info.startStr > isEditableDate) || isEditableDate == undefined)
            {
                openNewEventModal(eventRecordUrl, info.startStr, info.endStr, employeeId, filterColumnName ?? "[Employees_EmployeeId].[EmployeeId]");
            }
        },
        dayCellDidMount: function (info) {
            setWeekendColors(info);
        },
        dayHeaderFormat: function (date) {
            return moment(date.date).locale(date.localeCodes).format('ddd Do');
        },
    };
    return calendarOptions;
}